import React from "react";
import AdminForm from "../components/AdminForm";
import useAdminForm from "../hooks/useAdminForm";

export default function AdminFormInterface(props) {
  const {
    id,
    formName,
    contentAsText,
    submitting,
    parseError,
    onFormNameChange,
    onContentChange,
    handleSave,
  } = useAdminForm(props);

  const { onCancelAction } = props;

  return (
    <AdminForm
      id={id}
      formName={formName}
      contentAsText={contentAsText}
      submitting={submitting}
      parseError={parseError}
      onFormNameChange={onFormNameChange}
      onContentChange={onContentChange}
      handleSave={handleSave}
      onCancelAction={onCancelAction}
    />
  );
}
